import { injectable } from "inversify";
import IStatesManager from "./IStatesManager";
import AbstractStates from "./AbstractStates";
import { STATES } from "./states";

@injectable()
export default class StatesManager implements IStatesManager {
	private _actual: AbstractStates;
	// private _storage: Record<string, AbstractStates> = {};
	private _stateName: string;

	private locked: boolean = false;

	register(states: AbstractStates) {
		this._actual = states;
	}

	// add(key: string, state: AbstractStates, mount: boolean = false) {
	//     this._storage[key] = state;
	//
	//     if(mount) {
	//         this.mount(key);
	//     }
	// }

	async setState(stateName: string, data?: any, reset: boolean = false) {
		if (
			(!reset && this._stateName === stateName) ||
			this.locked ||
			(stateName === STATES.FORCESPIN && this._stateName !== STATES.SPIN)
		) {
			return;
		}

		this._stateName = stateName;
		return await this._actual.setState(stateName, data, reset);
	}

	getState(): string {
		return this._actual.getState();
	}

	getData() {
		return this._actual.getData();
	}

	// private mount(key:string) {
	//     this._actual = this._storage[key];
	// }

	resolve(state, data = this._actual.getData()) {
		this._actual.resolve(state, data);
	}

	reset(stateName = this.getState(), data = this.getData()): Promise<any> {
		return this.setState(stateName, data, true);
	}

	lock() {
		this.locked = true;
	}

	unlock() {
		this.locked = false;
	}
}
